import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "@helpers/translate";
import { formatAmountDisplay } from "@helpers/formatAmountWithSeparators";
import { WALLET_TYPE } from "@constants";

import "./index.sass";

const TopBalance = () => {
  const location = useLocation();
  const { __ } = useTranslation();

  const { wallets = [] } = useSelector((state) => state.wallet);
  const realWallet = wallets.find((wallet) => wallet.type === WALLET_TYPE.REAL_FUTURES);
  const balance = realWallet?.balance ?? 0;

  return (
    <div className="top-balance">
      <div className="top-balance__wrapper">
        <div className="top-balance__left">
          <h1 className="top-balance__title">
            {__("wallet.available_balance")}
          </h1>
        </div>

        <div className="top-balance__right">
          <p className="top-balance__balance">
            {formatAmountDisplay(balance)} USDT
          </p>

          <Link to="/" className="top-balance__trade-link">
            {__("wallet.trade")}
            <svg
              className="top-balance__trade-icon"
              width="8"
              height="13"
              viewBox="0 0 8 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.624816 12.9181C0.464816 12.9181 0.304792 12.8573 0.183125 12.7348C-0.0610417 12.4906 -0.0610417 12.0948 0.183125 11.8506L5.57477 6.45896L0.183125 1.06732C-0.0610417 0.823154 -0.0610417 0.427292 0.183125 0.183125C0.427292 -0.0610417 0.823154 -0.0610417 1.06732 0.183125L6.90065 6.01646C7.14482 6.26063 7.14482 6.65649 6.90065 6.90065L1.06732 12.734C0.944821 12.8573 0.784816 12.9181 0.624816 12.9181Z"
                fill="#FF6C22"
              />
            </svg>
          </Link>
        </div>
      </div>

      <div className="top-balance__list-btn">
        <Link
          to="/wallet/deposit"
          className={`top-balance__btn ${
            location.pathname === "/wallet/deposit"
              ? "top-balance__btn--active"
              : ""
          }`}
        >
          {__("wallet.deposit_top_balance")}
        </Link>

        <Link
          to="/wallet/withdrawal"
          className={`top-balance__btn ${
            location.pathname === "/wallet/withdrawal"
              ? "top-balance__btn--active"
              : ""
          }`}
        >
          {__("wallet.withdrawal_top_balance")}
        </Link>

        <Link
          to="/wallet/history"
          className={`top-balance__btn ${
            location.pathname === "/wallet/history"
              ? "top-balance__btn--active"
              : ""
          }`}
        >
          {__("wallet.transaction_history_top_balance")}
        </Link>
      </div>
    </div>
  );
};

export default TopBalance;
